import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { journalEntries } from "../data/journal";

const EASE = [0.22, 1, 0.36, 1];
const ROTATE_MS = 6000;

/* From the Journal — a rotating row of three cards, like the Journal's first row;
   auto-rotates slowly, arrows hand control to the visitor */
export default function JournalCarousel() {
  const [idx, setIdx] = useState(0);
  const [held, setHeld] = useState(false);
  const timer = useRef(null);
  const count = journalEntries.length;

  useEffect(() => {
    if (count < 2 || held) return;
    timer.current = setInterval(() => setIdx((i) => (i + 1) % count), ROTATE_MS);
    return () => clearInterval(timer.current);
  }, [count, held, idx]);

  if (count === 0) return null;

  const go = (dir) => () => {
    setHeld(true);
    setIdx((i) => (i + dir + count) % count);
  };

  const visible = [0, 1, 2].map((k) => journalEntries[(idx + k) % count]);

  return (
    <div
      className="journal-carousel"
      data-testid="journal-carousel"
      onMouseEnter={() => setHeld(true)}
      onMouseLeave={() => setHeld(false)}
    >
      <div className="eyebrow">From the Journal</div>
      <div className="jc-row-wrap">
        {count > 1 && (
          <button
            className="jc-arrow jc-prev"
            data-testid="journal-carousel-prev"
            onClick={go(-1)}
            aria-label="Previous journal entries"
          >
            ←
          </button>
        )}
        <div className="jc-row" data-testid="journal-carousel-row">
          <AnimatePresence mode="popLayout">
            {visible.map((entry, k) => (
              <motion.button
                key={entry.id}
                className="journal-card jc-card"
                data-testid={`journal-carousel-card-${k + 1}`}
                initial={{ opacity: 0, y: 14 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.7, ease: EASE }}
                onClick={() => {
                  window.location.hash = "/journal";
                }}
                aria-label={`Read ${entry.title} in the Journal`}
              >
                <span className="journal-card-media">
                  <img src={entry.image} alt={entry.title} loading="lazy" />
                </span>
                <span className="journal-card-title">{entry.title}</span>
              </motion.button>
            ))}
          </AnimatePresence>
        </div>
        {count > 1 && (
          <button
            className="jc-arrow jc-next"
            data-testid="journal-carousel-next"
            onClick={go(1)}
            aria-label="Next journal entries"
          >
            →
          </button>
        )}
      </div>
      {count > 1 && (
        <div className="jc-count">
          {String(idx + 1).padStart(2, "0")} / {String(count).padStart(2, "0")}
        </div>
      )}
    </div>
  );
}
